export enum StatusMessageEnum {
  error = 'error',
  success = 'success',
  warning = 'warning',
  notice = 'notice'
}
